﻿
// js dependencies...
import 'jquery';
import 'jquery-ajax-unobtrusive';
import 'parsleyjs';
import 'blueimp-file-upload';
// pollyfills
//import './libs/details-pollyfill';
//import './libs/focus-within-polyfill';

// custom js depenencies...
import './modules/videos';
import './modules/news';
import './modules/land-portfolio';


// 'legacy' js - only required for corporate site
import '../js/v2/pageInit';
import '../js/v2/forms';
// do not use this just yet, it needs more work
// import './modules/nav-drop-sizer';

// loaders have been added to webpack for .css, woff/woff2, .ttf & .svg
// import any here that are to be bundled
